import React from 'react';
import InstitucionalFrame from './InstitucionalFrame';

const InstitucionalParceiros: React.FC = () => (
  <InstitucionalFrame page="parceiros.html" title="Parceiros InPlay" />
);

export default InstitucionalParceiros;
